import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";

/**
 * Tipado del contexto
 */
type ThemeContextType = {
  isNight: boolean;
  toggleNightMode: () => void;
};

/**
 * Crear el contexto
 */
const AppThemeContext = createContext<ThemeContextType | undefined>(undefined);

/**
 * Componente proveedor del contexto
 */
export const AppThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isNight, setIsNight] = useState<boolean>(false);

  useEffect(() => {
    const stored = localStorage.getItem("isNight");
    if (stored) {
      setIsNight(stored === "true");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("isNight", String(isNight));
  }, [isNight]);

  useEffect(() => {
    if (isNight) {
      document.body.classList.add("night");
    } else {
      document.body.classList.remove("night");
    }
  }, [isNight]);

  const toggleNightMode = () => {
    setIsNight((prev) => !prev);
  };

  const contextValues: ThemeContextType = {
    isNight,
    toggleNightMode,
  };

  return (
    <AppThemeContext.Provider value={contextValues}>
      {children}
    </AppThemeContext.Provider>
  );
};

/**
 * Hook personalizado para consumir el contexto
 */
export const useTheme = (): ThemeContextType => {
  const context = useContext(AppThemeContext);
  if (!context) {
    throw new Error();
  }
  return context;
};
